import Skeleton from 'components/_UI/Skeleton'
import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'

export default function DashboardEventCardSkeleton() {
    return (
        <CardSkeleton>
            <Skeleton
                width="100%"
                height="121px"
                style={{ borderRadius: '12px 12px 0 0' }}
            />

            <BadgeSkeleton>
                <Skeleton
                    width="65px"
                    height="20px"
                    style={{ borderRadius: '8px' }}
                />
            </BadgeSkeleton>

            <BodySkeleton>
                <Skeleton
                    width="70%"
                    height="12px"
                    style={{ marginBottom: '8px' }}
                />
                <Skeleton
                    width="85%"
                    height="14px"
                    style={{ marginBottom: '8px' }}
                />
                <Skeleton
                    width="60%"
                    height="12px"
                />
            </BodySkeleton>
        </CardSkeleton>
    )
}

const CardSkeleton = styled.div`
    width: 230px;
    height: 220px;
    border-radius: 12px;
    background: #fff;
    margin: 5px;
    position: relative;
    flex-shrink: 0;

    @media screen and (min-width: ${breakpoints.md}) {
        width: 250px;
        margin: 5px 10px;
    }
`

const BadgeSkeleton = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
`

const BodySkeleton = styled.div`
    padding: 10px;
`
